var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisconnect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1161_7344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.63098 5.34376L6.03824 2.75102C5.08361 1.79641 3.56778 1.76453 2.65248 2.67982C1.73718 3.59509 1.76906 5.11096 2.72368 6.06559L5.31641 8.65829",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6388 7.35693L13.2315 9.94967C14.1861 10.9043 14.3098 12.3744 13.3027 13.3354C12.2957 14.2964 10.8716 14.2188 9.91695 13.2642L7.32422 10.6715",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.07957 7.02537L5.7832 5.729",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1045 10.0502L8.80811 8.75391",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 1.42847C10.3157 1.42847 10.5716 1.6843 10.5716 1.9999V3.9999C10.5716 4.31549 10.3157 4.57132 10.0001 4.57132C9.68455 4.57132 9.42871 4.31549 9.42871 3.9999V1.9999C9.42871 1.6843 9.68455 1.42847 10.0001 1.42847Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00014 11.4287C6.31573 11.4287 6.57157 11.6845 6.57157 12.0001V14.0001C6.57157 14.3157 6.31573 14.5716 6.00014 14.5716C5.68455 14.5716 5.42871 14.3157 5.42871 14.0001V12.0001C5.42871 11.6845 5.68455 11.4287 6.00014 11.4287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5713 6.00014C14.5713 6.31573 14.3155 6.57157 13.9999 6.57157L11.9999 6.57157C11.6843 6.57157 11.4284 6.31573 11.4284 6.00014C11.4284 5.68455 11.6843 5.42871 11.9999 5.42871L13.9999 5.42871C14.3155 5.42871 14.5713 5.68455 14.5713 6.00014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57129 10.0001C4.57129 10.3157 4.31545 10.5716 3.99986 10.5716H1.99986C1.68427 10.5716 1.42843 10.3157 1.42843 10.0001C1.42843 9.68455 1.68427 9.42871 1.99986 9.42871H3.99986C4.31545 9.42871 4.57129 9.68455 4.57129 10.0001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1161_7344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnect);
export default __webpack_public_path__ + "static/media/disconnect.df1a5602332b6306c3d3d6df60be9b13.svg";
export { ForwardRef as ReactComponent };